import styled from 'styled-components';

export const DefaultText = styled.span`
  font-size: ${({ theme }) => theme.fonts.fontSize.base};
  font-weight: ${({ theme }) => theme.fonts.fontWeight.regular};
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.white};
`;

export const PremierText = styled.span`
  padding-right: 4px;
  font-family: ${({ theme }) => theme.fonts.fontFamily.leagueGothic};
  font-size: ${({ theme }) => theme.fonts.fontSize.base};
  font-weight: ${({ theme }) => theme.fonts.fontWeight.regular};
  font-style: italic;
  letter-spacing: 0.02em;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.white};
  text-transform: uppercase;
`;

export const GradientPremierText = styled(PremierText)`
  background: linear-gradient(
    120deg,
    ${({ theme }) => theme.colors.red[500]} 20%,
    ${({ theme }) => theme.colors.purple[500]} 50%,
    ${({ theme }) => theme.colors.blue[500]} 80%
  );
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
`;
